import { DEFAULT_VERTICAL, VERTICAL_CODES, type VerticalCode } from './codes'
import { diningManifest } from './dining/manifest'
import { staysManifest } from './stays/manifest'
import type { VerticalManifest } from './types'

const MANIFESTS: Record<VerticalCode, VerticalManifest> = {
  stays: staysManifest,
  dining: diningManifest,
}

export function getManifest(code: VerticalCode | null | undefined): VerticalManifest {
  return MANIFESTS[code ?? DEFAULT_VERTICAL]
}

export function allManifests(): VerticalManifest[] {
  return VERTICAL_CODES.map((code) => MANIFESTS[code])
}
